import React, { useState, useRef } from "react";
import { useTheme } from "../config/ThemeContext";
import apiClient from "../services/apiClient";

export default function CreatePlayerForm({ onCreate, teamId, setPlayers, getPlayersByTeam, refreshPlayers }) {
  const colors = useTheme();
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [failedRows, setFailedRows] = useState([]);

  const initial = {
    shirtNumber: "", lastName: "", firstName: "", shirtName: "",
    position: "Libero", birthdate: "", weight: "", height: "",
    spikeReach: "", blockReach: "", federationOfOrigin: "", fivbNo: "", isCaptain: false
  };
  const [form, setForm] = useState(initial);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    if (!form.shirtNumber || !form.lastName) return alert("Shirt Number and Last Name are required.");
    onCreate(form);
    setForm(initial);
  };

const handleFileUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("file", file);

  setUploading(true);
  setMessage("");
  setFailedRows([]);

  try {
    const res = await apiClient.post(`/api/players/upload?teamId=${teamId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    setMessage(res.data.message || "Upload complete.");
    setFailedRows(res.data.failedRows || []);

    if (refreshPlayers) await refreshPlayers(); // ✅ refresh the list
  } catch (err) {
    setMessage("Upload failed. " + (err.response?.data?.error || "Unknown error"));
  } finally {
    setUploading(false);
    if (fileInputRef.current) fileInputRef.current.value = null;
  }
};



  const fields = [
    { key: "shirtNumber", type: "number" }, { key: "lastName" }, { key: "firstName" },
    { key: "shirtName" }, { key: "birthdate", type: "date" }, { key: "position", type: "select" },
    { key: "weight", type: "number" }, { key: "height", type: "number" },
    { key: "spikeReach", type: "number" }, { key: "blockReach", type: "number" },
    //{ key: "federationOfOrigin" }, 
	//{ key: "fivbNo" }
  ];

  return (
    <>
      <div className={`bg-white rounded-xl shadow-md p-6 mb-8 border-t-4 ${colors.primary.border}`}>
        <h2 className={`text-xl font-semibold ${colors.neutral.text} mb-4`}>Add New Player</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {fields.map(({ key, type }) => (
            <div key={key}>
              <label className={`block text-sm font-medium ${colors.neutral.lightText} mb-1`}>
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </label>
              {type === "select" ? (
                <select
                  value={form[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                  className={`w-full px-4 py-2 border ${colors.neutral.border} rounded-lg focus:ring-2 ${colors.primary.focusRing}`}
                >
                  {["Libero", "Wing Spiker", "Opposite", "Middle Blocker", "Setter", "Outside Hitter"].map((opt) => (
                    <option key={opt}>{opt}</option>
                  ))}
                </select>
              ) : (
                <input
                  type={type || "text"}
                  value={form[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                  className={`w-full px-4 py-2 border ${colors.neutral.border} rounded-lg focus:ring-2 ${colors.primary.focusRing}`}
                />
              )}
            </div>
          ))}
          <div className="flex items-center mt-2">
            <input
              type="checkbox"
              checked={form.isCaptain}
              onChange={(e) => handleChange("isCaptain", e.target.checked)}
              className="mr-2"
            />
            <label className={colors.neutral.text}>Captain</label>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <button onClick={handleSubmit} className={colors.buttons.primary}>Add Player</button>
        </div>
      </div>

      <div className={`bg-white rounded-xl shadow-md p-6 my-6 border-t-4 ${colors.primary.border}`}>
        <h2 className="text-xl font-semibold mb-4">Upload Players from Excel</h2>
        <a
          href="/Team_Upload_Template.xlsx"
          download
          className="text-blue-600 underline mb-2 inline-block"
        >
          Download Sample Template
        </a>
        <input
          type="file"
          accept=".xlsx"
          ref={fileInputRef}
          onChange={handleFileUpload}
          className="block mb-4"
        />
        {uploading && <p className="text-gray-500 mb-2">Uploading...</p>}
        {message && <p className="mb-2 text-gray-800">{message}</p>}
        {failedRows.length > 0 && (
          <ul className="list-disc pl-5 text-red-600">
            {failedRows.map(({ row, reason }) => (
              <li key={row}>Row {row}: {reason}</li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}
